<template>
    <div>
        <v-row>
            <span>{{ event.event_type_name }}</span>
        </v-row>
        <v-row class="d-flex align-start">
            <DatePicker
                :label="$t('Дата плановая')"
                class="d-inline-block mr-15 date-picker"
                v-model="event.event_start"
                :clearable="true"
                :rules="requiredWhenDateEnd"
                :max="null"
            />
            <DatePicker :label="$t('Дата фактическая')" class="d-inline-block mr-15 date-picker" v-model="event.event_end" :clearable="true" />
        </v-row>
    </div>
</template>

<script>
import BinCheckMixin from '@/mixins/BIN_Checker';
import FormValidator from '@/mixins/FormValidator';
import DatePicker from '@/components/ui/DatePicker';

export default {
    name: 'EventEdit',
    mixins: [BinCheckMixin, FormValidator],
    props: ['event'],
    components: { DatePicker },
    computed: {
        requiredWhenDateEnd: function(v) {
            let req = !this.event.event_start && this.event.event_end;
            return [v => !req || this.$t('Обязательное поле')];
        }
    }
};
</script>
